import { useState, useEffect, useCallback } from 'react';
import { useUserStore, useCompanyStore } from 'stores';
import useLocalePath from 'utils/customHooks/useLocalePath';

const useAssignedLibrary = () => {
  const { slug } = useCompanyStore();
  const { isLogged, assigned_library } = useUserStore();
  const [assignedLibrary, setAssignedLibrary] = useState(slug);
  const localePath = useLocalePath();

  useEffect(() => {
    if (isLogged && assigned_library?.slug  && assigned_library?.slug !== null) {
      setAssignedLibrary(assigned_library?.slug);
    } else {
      setAssignedLibrary(slug); 
    }
  }, [isLogged, assigned_library, slug]);

  const libraryPath = useCallback(
    (suffix = '') => {
      const cleanSuffix = suffix.replace(/^\//, '');
      return localePath(`/${assignedLibrary}/${cleanSuffix}`);
    },
    [assignedLibrary, localePath],
  );

  return { assignedLibrary, libraryPath };
};

export default useAssignedLibrary;
